
export class FormatDateException extends Error { }
